import { useUserPledgesList } from "CrossFeatureComponents/UserPledgesList/UserPledgesListContext";
import { useManageMyGivingPage } from "Giving/ManageMyGivingPage/ManageMyGivingPageContext";

export function useShouldShowPledgesTab() {
  const { state: pageState } = useManageMyGivingPage();
  const { state: pledgesState } = useUserPledgesList();

  const hasCurrentPledge = pledgesState.pledges?.length > 0;
  const hasPledgeableCampaigns = pageState.pledgeableCampaigns?.length > 0;

  return hasCurrentPledge || hasPledgeableCampaigns;
}
